
import moment from 'moment-timezone'
import EventCardTags from './EventCardTags.vue'
import EventCardLectors from './EventCardLectors.vue'
import EventCardSmall from './EventCardSmall.vue'
import EventCardLinkButton from './EventCardLinkButton.vue'

export default {
  name: 'EventCard',
  components: {
    EventCardLinkButton,
    EventCardSmall,
    EventCardLectors,
    EventCardTags
  },

  props: {
    event: {
      type: Object,
      required: true
    },

    isInBottomSheet: {
      type: Boolean,
      default: false
    },

    isInSchedule: {
      type: Boolean,
      default: false
    },

    isHoliday: {
      type: Boolean,
      default: false
    },

    isTooltip: {
      type: Boolean,
      default: false
    },

    maxAvatars: {
      type: Number,
      default: 2,
      required: false
    },

    container: {
      type: String,
      default: 'default',
      validator: value => ['widget', 'default'].includes(value)
    }
  },

  data() {
    return {
      isMobileDevice: this.$device.isMobile
    }
  },

  computed: {
    courseTitle() {
      return this.event?.extra?.courseTitle
        ? `Курс: ${this.event.extra.courseTitle}`
        : null
    },

    isEventPast() {
      const startTime = this.event?.period?.from
      if (startTime) {
        return moment(startTime).add(2, 'hours').isBefore(moment())
      }

      return this.event?.status === 'done'
    },

    isHomework() {
      return this.event?.type?.slug === 'homework'
    },

    eventTeacherGroups() {
      if (
        this.event.userRole === 'teacher' &&
        this.event?.extra?.groups?.length > 0
      ) {
        const text = this.event?.extra?.groups?.length > 1 ? 'Группы' : 'Группа'

        return `${text}: ${this.event?.extra?.groups.join(', ')}`
      }

      return null
    },

    holidaysText() {
      if (this.isHoliday) {
        return {
          title: `C ${moment(this.event?.from).format('D MMMM')} по ${moment(
            this.event?.to
          ).format('D MMMM')}`,

          description: 'Отдыхайте и набирайтесь сил для старта',
          description_date: moment(this.event?.to)
            .add(1, 'day')
            .format('D MMMM.')
        }
      }

      return null
    },

    whatTimeToShow() {
      return this.isHomework
        ? this.deadlineTime.toString()
        : this.startTime.toString()
    },

    startTime() {
      const { period } = this.event
      const endTime = period?.to
      const startTime = moment(period?.from).format('HH:mm')

      if (endTime) {
        return `${startTime} - ${moment(endTime).format('HH:mm')}`
      }

      const defaultEndTime = moment(period?.from)
        .add(2, 'hours')
        .format('HH:mm')

      return `${startTime} - ${defaultEndTime}`
    },

    deadlineTime() {
      return this.isMobileDevice
        ? moment(this.event?.period?.to).format('HH:mm')
        : `Дедлайн до ${moment(this.event?.period?.to).format('HH:mm')}`
    },

    cardText() {
      return this.event?.title || this.holidaysText?.title || ''
    },

    lectors() {
      return this.event?.lectors || []
    }
  }
}
